import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import getReportAttendanceHostDetail from 'Api/report-attendance-host-detail/getReportAttendanceHostDetail';

import getReportAttendanceHostDetailRequest from './model/request/getReportAttendanceHostDetailRequest';
import getReportAttendanceHostDetailResponse from './model/response/getReportAttendanceHostDetailResponse';

const useGetReportAttendanceHostDetail = (filter) => {
  const { t } = useTranslation('report-attendance-host-detail');
  return useQuery({
    queryKey: ['report-attendance-host-detail', filter],
    queryFn: async () => {
      const queries = getReportAttendanceHostDetailRequest(filter);

      const response = await getReportAttendanceHostDetail(queries);

      return getReportAttendanceHostDetailResponse(response, t);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: filter?.startedAt != null && filter?.endedAt !== null,
  });
};

export default useGetReportAttendanceHostDetail;
